var React = require('react');

function ReviewStarInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 0L19.8492 8.32561L29.2658 10.3647L22.8462 17.5494L23.8168 27.1353L15 23.25L6.18322 27.1353L7.15378 17.5494L0.734152 10.3647L10.1508 8.32561L15 0Z","fill":"#E6E7EA"}));
}

ReviewStarInline.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 28","fill":"none"};

module.exports = ReviewStarInline;

ReviewStarInline.default = ReviewStarInline;
